import * as React from 'react';
import { TUnauthRoute } from './UnauthRoute.types';
import { Navigate } from 'react-router';
import { useAppSelector } from 'store/store';
import { APP_ROUTES } from 'constants/routes';

export const UnauthRoute: TUnauthRoute = ({ children }) => {
  const { data: currentUser } = useAppSelector(
    (state) => state.users.currentUser
  );

  if (currentUser?.id) {
    return <Navigate to={APP_ROUTES.HOME} />;
  }

  return children;
};
